import React, { Fragment, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import TabPanel from "@components/tab-panel";
import { Grid, Typography, Box, Divider, Button } from "@mui/material";
import Currency from "@components/currency";
import { actions as MenuActions } from "@store/menu/reducer";
import { useHistory } from "react-router-dom";

import "./styles.css";
import ImageContainer from "@components/image-component";

function SubCategoryMenu(props) {
  const { menu, selectedTab, selectedSubCategoryTab } = useSelector(
    (state) => state.menu
  );
  const { stickyHeader } = useSelector((state) => state.ui);
  const { orderTypes, tenantId } = useSelector((state) => state.outlet);
  const history = useHistory();

  const dispatch = useDispatch();

  const selectItem = (item) => {
    dispatch(MenuActions.updateSelectedItem(item));
  };

  const getSafeArray = (item) => {
    if (item) {
      return item;
    }
    return [];
  };

  const getCalories = (attributes = []) => {
    const [cal] = attributes.filter(
      (attribute) => attribute.key === "calories"
    );
    return cal?.value;
  };

  const shouldHideItem = ({ visible, ...item }) => {
    if (!visible) {
      return true;
    }
  };

  // const scrollToSubCategory = () => {
  //   try {
  //     const selectedCategory = menu.categories[selectedTab];
  //     const selectedSubCategory =
  //       selectedCategory?.categories[selectedSubCategoryTab];
  //     const { categoryId } = selectedSubCategory;

  //     const element = document.getElementById(categoryId);
  //     const offset = 0;
  //     const bodyRect = document.body.getBoundingClientRect().top;
  //     const elementRect = element.getBoundingClientRect().top;
  //     const elementPosition = elementRect - bodyRect;
  //     const offsetPosition = elementPosition - offset;

  //     const subCategoryContainer = document.getElementById("sub-menu-section");

  //     console.log({
  //       offsetPosition,
  //       bodyRect,
  //       elementRect,
  //       elementPosition,
  //       offsetPosition,
  //     });

  //     subCategoryContainer.scrollTo({
  //       top: offsetPosition,
  //       behavior: "smooth",
  //     });
  //   } catch (E) {
  //     console.log(E);
  //   }
  // };

  const scrollToSubCategory = () => {
    try {
      const selectedCategory = menu.categories[selectedTab];
      const selectedSubCategory =
        selectedCategory?.categories[selectedSubCategoryTab];
      const { categoryId } = selectedSubCategory;

      const subCategoryContainer = document.getElementById(categoryId);
      // ScrollToElement(`#${categoryId}`);

      const selectedElementHeight =
        subCategoryContainer.getBoundingClientRect().top;
      const bodyHeight = document
        .getElementById("menu-container")
        .getBoundingClientRect().height;

      console.log(bodyHeight < selectedElementHeight);

      // if (bodyHeight < selectedElementHeight) {
      //   document
      //     .getElementById("menu-container-2")
      //     .classList.add("sticky-overflow");
      // }

      let scrollTo = selectedElementHeight;

      if (selectedCategory?.categories.length > 1) {
        subCategoryContainer.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      }

      // scroll.scrollToTop();
      // if (bodyHeight < selectedElementHeight) {
      //   scrollTo -= 210;
      // } else {
      //   scrollTo += 35;
      // }
      // scroll.scrollTo(scrollTo);
      // console.log({ selectedCategory, selectedElementHeight, scrollTo });

      // document.getElementById("menu-container").scrollTo({ top: scrollTo });
    } catch (E) {
      console.log(E);
    }
  };

  const getMinimumHeight = (index, array) => {
    return index + 1 === array.length ? "calc(100vh - 180px)" : null;
  };

  const getMaxHeight = () => {
    const selectedCategory = menu.categories[selectedTab];
    if (selectedCategory?.categories.length > 1) {
      return "calc(100vh - 200px)!important";
    }
    return "calc(100vh - 140px)!important";
  };

  const getOverflow = () => {
    const selectedCategory = menu.categories[selectedTab];
    return selectedCategory?.categories.length > 1 ? "scroll" : null;
  };

  useEffect(() => {
    scrollToSubCategory();
  }, [selectedSubCategoryTab]);

  if (!getSafeArray(menu.categories).length || !orderTypes.length) {
    return (
      <Grid container rowSpacing={2} sx={{ p: 3 }}>
        <Grid item xs={12}>
          <Typography variant="h1" sx={{ fontSize: 35 }}>
            Sorry!
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h1">This menu is not available.</Typography>
        </Grid>
        {tenantId && (
          <Grid item xs={12}>
            <Button
              variant="contained"
              sx={{
                borderRadius: "30px",
              }}
              onClick={() =>
                tenantId ? history.push(`/tenant/${tenantId}`) : null
              }
            >
              See Other Menu's
            </Button>
          </Grid>
        )}
      </Grid>
    );
  }

  return (
    <Box
      id="menu-container-2"
      sx={{ maxHeight: getMaxHeight(), overflowY: getOverflow() }}
    >
      {getSafeArray(menu.categories).map((category, index) => {
        return (
          <TabPanel
            value={selectedTab}
            index={index}
            key={category.categoryId}
            className="sub-category-menu"
            id={category.categoryId}
          >
            <Grid container>
              {category.imageUrl && (
                <Grid item xs={12}>
                  <Box
                    component="img"
                    src={category.imageUrl}
                    sx={{
                      maxWidth: "100%",
                      maxHeight: "100px",
                      margin: "0 auto",
                      display: "block",
                    }}
                    alt={category.name}
                  />
                </Grid>
              )}
              {getSafeArray(category?.categories).map(
                (subCategory, subCategoryIndex) => {
                  return (
                    <div
                      key={subCategory.categoryId}
                      style={{
                        width: "100%",
                        minHeight: getMinimumHeight(
                          subCategoryIndex,
                          getSafeArray(category?.categories)
                        ),
                      }}
                      id={subCategory.categoryId}
                    >
                      <Grid item xs={12} className="sub-category">
                        <Box
                          sx={{
                            pl: 2,
                            pr: 3,
                            pt: "6px",
                            pb: "6px",
                            fontSize: 18,
                          }}
                        >
                          {subCategory.imageUrl ? (
                            <Box
                              component="img"
                              src={subCategory.imageUrl}
                              sx={{
                                maxWidth: "100%",
                                maxHeight: "100px",
                                margin: "0 auto",
                                display: "block",
                              }}
                              alt={subCategory.name}
                            />
                          ) : (
                            <Typography variant="h2">
                              <strong>{subCategory.name}</strong>
                            </Typography>
                          )}
                        </Box>
                      </Grid>
                      {getSafeArray(subCategory?.items).map(
                        (item, subIndex) => {
                          if (shouldHideItem(item)) {
                            return null;
                          }

                          return (
                            <Fragment key={item.itemId}>
                              <Grid item xs={12}>
                                <Grid container>
                                  <Grid
                                    item
                                    xs={9}
                                    onClick={() => {
                                      selectItem(item);
                                    }}
                                  >
                                    <Box sx={{ pl: 2, pb: 2.5, pt: 2.5 }}>
                                      <Typography
                                        variant="h3"
                                        sx={{ fontSize: "0.875rem" }}
                                      >
                                        <strong>{item.name}</strong>
                                      </Typography>

                                      {item.price > 0 && (
                                        <Typography
                                          variant="h3"
                                          sx={{ pb: 1, pt: 1 }}
                                        >
                                          <Currency value={item.price} />
                                        </Typography>
                                      )}

                                      {item.description && (
                                        <Typography
                                          variant="h4"
                                          sx={{ color: "#7C7C7C" }}
                                        >
                                          <strong
                                            dangerouslySetInnerHTML={{
                                              __html: item.description,
                                            }}
                                          ></strong>
                                          {/* <strong>{item.description}</strong> */}
                                        </Typography>
                                      )}
                                    </Box>
                                  </Grid>

                                  {item.imageUrl && (
                                    <Grid
                                      item
                                      xs={3}
                                      onClick={() => {
                                        selectItem(item);
                                      }}
                                    >
                                      <Box
                                        sx={{ pr: 2, pb: 2.5, pt: 2.5 }}
                                        align="right"
                                      >
                                        <ImageContainer
                                          imageUrl={item.imageUrl}
                                          altText={item.name}
                                          fit="cover"
                                        />
                                      </Box>
                                    </Grid>
                                  )}
                                </Grid>
                              </Grid>

                              {subCategory.items.length !== subIndex + 1 && (
                                <Grid item xs={12}>
                                  <Box sx={{ pr: 2, pl: 2 }}>
                                    <Divider />
                                  </Box>
                                </Grid>
                              )}
                            </Fragment>
                          );
                        }
                      )}
                    </div>
                  );
                }
              )}
            </Grid>
          </TabPanel>
        );
      })}
    </Box>
  );
}

export default SubCategoryMenu;
